import { render, staticRenderFns } from "./BallotList.vue?vue&type=template&id=04e41583&"
import script from "./BallotList.vue?vue&type=script&lang=js&"
export * from "./BallotList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports